export default __webpack_public_path__ + "static/media/Armbands of the Riftcaller.c9be45b7.jpg";